module.exports = __webpack_public_path__ + "static/media/ENCONTRO_8_ED_FISICA.7fa7c006.pdf";